import React from 'react';
import styled from '../../../theme';

export interface IProps {
  color?: string;
  'data-testid'?: string;
}

const StyledFormContainer = styled.div<IProps>`
  position: relative;
  background: ${(props) => props.color || 'rgb(27,31,77)'};
  padding: 3rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const FormContainer: React.FC<IProps> = ({ children, color, 'data-testid': dataTestId, ...rest }) => (
  <StyledFormContainer color={color} data-testid={`form-container-${dataTestId}`} {...rest}>
    {children}
  </StyledFormContainer>
);

export default FormContainer;
